export default {"src":"/_next/static/image/public/images/RxNumberPic.9b1e744b1075aba53a149461c9fb2d95.svg","height":247,"width":381};